<template>
  <section
    id="batchingID"
    class="new-case-view case-creation"
    v-loading="loading"
  >
    <div class="container-xs">
      <div class="primary-content-view-new">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table :data="form.data" height="calc(100vh - 140px)">
            <el-table-column
              label="Accession ID"
              prop="accession_id"
              width="140"
            ></el-table-column>
            <el-table-column
              prop="created_at"
              label="Created At"
              width="140"
              class="table_cell-ellipsis"
            >
              <template #default="scope">
                <div class="table_cell-ellipsis">
                  {{ momentWithTimezone(scope.row.created_at, "MM-DD-yyyy") }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Report Status" width="140">
              <template #default="scope">
                <div class="column-status">
                  <el-tag :type="getStatus(scope.row.report_status)">
                    {{ scope.row.report_status }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="updated_at"
              label="Updated At"
              width="150"
              class="table_cell-ellipsis"
            >
              <template #default="scope">
                <div class="table_cell-ellipsis">
                  {{ momentWithTimezone(scope.row.updated_at, "MM-DD-yyyy") }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="message"
              label="Reason"
              width="250"
              class="table_cell-ellipsis"
            >
              <template #default="scope">
                <div class="table_cell-ellipsis">
                  {{ scope.row.message ? scope.row.message : "--" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Actions" min-width="160">
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li v-if="scope.row.report_status == 'COMPLETED'">
                    <span class="action-btn cursor" @click="onView(scope.row)">
                      <img
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                    </span>
                  </li>
                  <li v-if="scope.row.report_status == 'COMPLETED'">
                    <span
                      @click="onDownloadReport(scope.row)"
                      style="margin: 10px"
                      class="action-btn cursor"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/download-new-active.svg"
                        alt="icon"
                      />
                    </span>
                  </li>

                  <li
                    v-if="
                      scope.row.report_status == 'COMPLETED' &&
                      !scope.row.is_finalized && hasPermission('cases', 'report_upload_new')
                    "
                  >
                    <el-button
                      class="finalize-btn"
                      title="Finalize Report"
                      @click="finalizeReport(scope.row)"
                      :disabled="
                        !hasPermission('test_report', 'finalize_report')
                      "
                    >
                      Finalize
                    </el-button>
                  </li>
                  <li
                    class="finalized-button d-flex align-center"
                    v-if="scope.row.is_finalized == true"
                  >
                    <el-button class="finalized-btn">Finalized </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div
      v-if="
        reportData && reportData.report_path && reportData.report_path.length
      "
    >
      <div
        class="default-modal vue-modal"
        v-if="viewReportPopup"
        v-loading="loading"
      >
        <el-dialog top="10%" width="45%" v-model="viewReportPopup">
          <div class="dialog-header">
            <span class="header-part">View PGx Report</span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="viewReportPopup = false"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
            /></el-button>
          </div>
          <div class="view-report">
            <el-row>
              <el-col>
                <div class="view-report-popup-view">
                  <ul class="reports-header">
                    <li class="value-header">
                      <h4 style="font-size: 15px">Report Title</h4>
                    </li>
                    <li class="value-header">
                      <h4 style="font-size: 15px">Action</h4>
                    </li>
                  </ul>
                  <ul
                    v-for="(report, index) in reportData.report_path"
                    :key="index"
                    class="reports-data"
                  >
                    <li>
                      <span class="reports-details">
                        {{ report }}
                      </span>
                    </li>
                    <li>
                      <span
                        class="action-btn cursor"
                        @click="onView(reportData, report)"
                      >
                      </span>
                    </li>
                    <li>
                      <span class="reports-details">
                        {{ reportData.report_path }}
                      </span>
                    </li>
                    <li>
                      <span
                        class="action-btn cursor"
                        @click="onView(reportData, report)"
                      >
                        <img
                          src="@/assets/images/icons/actions/view-icon.svg"
                          alt="icon"
                        />
                      </span>
                      <span
                        @click="onDownloadReport(report)"
                        style="margin: 10px"
                        class="action-btn cursor"
                        v-if="
                          reportData.is_finalized == true ||
                          reportData.report_status == 'COMPLETED'
                        "
                      >
                        <img
                          class="action-active"
                          src="@/assets/images/icons/actions/download-new-active.svg"
                          alt="icon"
                        />
                      </span>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-dialog>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import FileDownloadHelper from "@/mixins/FileDownloadHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  name: "CardiacCasesForReport",
  mixins: [UserPermissionsHelper, FileDownloadHelper],
  data() {
    return {
      viewReportPopup: false,
      reportData: {},
      loading: false,
      dialogSelectCase: false,
      case_type: "",
      loadingText: "Loading...",
      form: {
        title: "",
        case_type: "",
        status: "ACTIVE",
        sent_status: false,
        report_data: "",
        accession_data: [],
      },
      reportFileId: "",
    };
  },
  computed: {
    getScreenHeight() {
      return screen.height - 200;
    },
    getStatus() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "PROCESSING") {
          return "default";
        } else if (status == "COMPLETED") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "TO-START") {
          return "info";
        } else if (status == "FAILED") {
          return "danger";
        } else {
          return "";
        }
      };
    },
    isEdit() {
      return this.$route.params.id ? true : false;
    },
    ...mapGetters("tsiReports", [
      "getSingleReportFile",
      "getSingleDemographicStatus",
      "getSingleSyncReportStatus",
      "getPdfFileDownloadUrl",
      "getFileDownloadStatus",
      "getFinalizeReportStatus",
      "getViewReportUrl",
      "getReportDownload",
    ]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    ...mapGetters("cases", ["getDownloadReportData"]),
    ...mapGetters("respiratoryFileUpload", ["getFileDownloadUrl"]),
    ...mapGetters("respiratoryFileUpload", ["getSampleNameTestResultData"]),
  },
  async mounted() {
    if (this.$route.params.id) {
      this.reportFileId = this.$route.params.id;
      await this.getReport();
    }
  },
  methods: {
    async getReport() {
      this.loading = true;
      await this.$store.dispatch(
        "tsiReports/fetchSingleReport",
        this.$route.params.id
      );
      this.setFormData();
      this.loading = false;
    },

    setFormData() {
      this.form = { ...this.getSingleReportFile };
    },
    async sendSingleDemogrpahics(row) {
      let params = {
        accession_id: row.accession_id,
        report_id: this.$route.params.id,
      };
      this.loading = true;
      await this.$store.dispatch(
        "tsiReports/sendSinglePatientDemographics",
        params
      );
      this.loading = false;
      if (this.getSingleDemographicStatus) {
        successNotification(this.getSingleDemographicStatus.message);
        await this.getReport();
      } else {
        errorNotification(
          this.getSingleDemographicStatus.message || "Invalid Data"
        );
      }
    },
    //View report
    onViewReport(report) {
      this.viewReportPopup = true;
      this.reportData = report;
    },
    // Actions of single case
    async syncSingleReport(report) {
      let params = {
        report_id: this.$route.params.id,
        accession_id: report.accession_id,
      };
      this.loading = true;
      await this.$store.dispatch("tsiReports/sendSingleSyncReport", params);
      this.loading = false;
      if (this.getSingleSyncReportStatus) {
        successNotification(this.getSingleSyncReportStatus.message);
        this.getReport();
      } else if (!this.getErrors || this.getError) {
        this.$notify.error(this.getError);
      }
    },
    async onView(report) {
      let routerData = this.$router.resolve({
        name: "ReportPreview",
        params: {
          result_file_id: this.reportFileId,
          report_id: report._id,
        },
      });
      window.open(routerData.href, "_blank");
    },
    async onDownloadReport(report) {
      try {
        this.loading = true;
        let params = {
          result_file_id: this.reportFileId,
          report_id: report._id,
          report_type: "merged_report",
        };
        await this.$store.dispatch("tsiReports/downloadTSIFile", params);
        if (this.getReportDownload && this.getReportDownload.data) {
          let url = this.getReportDownload.data.url;
          window.open(url, "_blank");
        }
      } catch (error) {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },

    async finalizeReport(report) {
      try {
        this.loading = true;
        await this.$store.dispatch("tsiReports/finalizeReport", {
          result_file_id: this.$route.params.id,
          report_id: report._id,
        });

        if (this.getFinalizeReportStatus) {
          successNotification("Report Finalized successfully");
          this.loading = true;
          await this.getReport();
        } else if (!this.getErrors) {
          errorNotification("Error in finalize report");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async viewReport(report) {
      try {
        await this.$store.dispatch(
          "respiratoryFileUpload/fetchFileDownloadUrl",
          {
            path: report.report_path,
          }
        );

        let url = this.getPdfFileDownloadUrl.download_url;
        this.downloadFileAndPreviewFile(url);
      } catch (err) {
        this.loading = false;
      }
    },
    // End actions
  },
};
</script>

<style lang="scss" scoped>
@mixin button-css {
  border-radius: 4px !important;
  padding: 6px 5px;
  height: auto;
  min-height: 20px;
  line-height: 1;
  color: #fff;
  border: 0.6px solid #4bb543;
  color: #4bb543;
  min-width: 100px;
  font-weight: 500 !important;
  text-align: center;
  font-size: 12px !important;
  letter-spacing: 0px !important;
  &:hover,
  &:active,
  &:focus {
    border: 0.6px solid #4bb543;
    color: #4bb543;
  }
}
.btn-success {
  @include button-css;
}
.name-capital {
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 500;
  padding-left: 3px;
}
.btn-active {
  @include button-css;

  border: 0.6px solid #5162fd;
  color: #5162fd;
  &:hover,
  &:active {
    border: 0.6px solid #5162fd;
    color: #5162fd;
  }
  &.is-disabled {
    opacity: 0.5;
    border: 0.6px solid #5162fd;
    color: #5162fd;
    &:hover {
      opacity: 0.5;
      border: 0.6px solid #5162fd;
      color: #5162fd;
    }
  }
}
.btn-processing {
  @include button-css;
  border: 0.6px solid #f28b0c;
  color: #f28b0c;
  &:hover,
  &:active,
  &:focus {
    border: 0.6px solid #f28b0c;
    color: #f28b0c;
  }
}
.view-report {
  .view-report-popup-view {
    padding: 0 0 10px;
    .reports-header {
      display: grid;
      grid-template-columns: 85% 15%;
      column-gap: 20px;
      padding: 10px 15px;
      border-bottom: 0.633951px solid #e0e0e0;
      li {
        color: #273480;
        font-size: 16px;
      }
    }
    .reports-data {
      display: grid;
      grid-template-columns: 85% 15%;
      column-gap: 20px;
      padding: 5px 15px 5px 15px;

      .report-details {
        color: #262626;
        font-size: 13px;
        font-weight: 500;
      }
    }
  }
}
</style>
